<template>
  <div
    class="modal fade-right"
    id="RespModalMenu"
    tabindex="-1"
    aria-labelledby="RespModalMenuLable"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header d-flex justify-content-between py-2">
          <a class="all-categories-side-img mr-3"
            ><img src="@/assets/images/logo/logo-b.png" alt=""
          /></a>
          <button
            type="button"
            class="close m-0"
            data-dismiss="modal"
            aria-label="Close"
            @click="modalLabelClose()"
          >
            <span class="fontsize-xheavy" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!--resp menu -->
          <section class="all-categories-side bg-white pt-3 text-right">
            <div
              v-if="menu"
              class="accordion pb-3 border-radius15"
              id="accordionExample10"
            >
              <div></div>
              <div v-for="item in menu" :key="item.id" class="card">
                <div
                  class="card-header my-1 pr-3 d-flex justify-content-between"
                  id="headingOne"
                >
                  <a
                  data-dismiss="modal"
                    @click="
                      findUrlAndClose(
                        item.linkable_type,
                        item.linkable_id,
                        item.slug
                      )
                    "
                    class="d-flex my-auto text-color-444 font-weight-bold"
                  >
                    <span
                      class="
                        circle-list
                        bg-color-theme
                        rounded-circle
                        mt-1
                        ml-3
                      "
                    ></span>
                    {{ item.title }}
                  </a>
                  <button
                    v-show="item.children.length != 0"
                    class="all-categories-side-btn collapsed"
                    type="button"
                    data-toggle="collapse"
                    :data-target="'#mobileMenuChild' + item.id"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    <!-- <span>دسته 1</span> -->
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19 8.5L12 15.5L5 8.5"
                        stroke="#200E32"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>

                <div
                  v-show="item.children.length != 0"
                  :id="'mobileMenuChild' + item.id"
                  class="sub-all-categories-side-btn text-right collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample10"
                >
                  <div class="card-body py-0">
                    <ul class="all-categorie-sub-menu pr-3">
                      <li v-for="child in item.children" :key="child.id">
                        <a
                        data-dismiss="modal"
                          @click="
                            findUrlAndClose(
                              item.linkable_type,
                              item.linkable_id,
                              item.slug
                            )"
                          >{{ child.title }}</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!--resp menu button-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";
export default {
  name: "RespModalMenu",
  methods: {
    modalLabelClose() {
      document.getElementById("RespModalMenu").classList.add("show");
      this.$router.replace(this.$route.fullPath.replace("#menu", "")).catch(e => {});

    },
    findUrlAndClose(type, id, slug) {
      console.log(type);
      let router = this.findUrl(type, id, slug);
      this.$router.push(router);
    },
    findUrl,


  
  },
  computed: {
    menu() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return this.$store.getters["front/getHomeData"];
      } else {
        return this.$store.getters["front/getHomeData"].menu.header;
      }
    },
  },
  watch: {
    "$route.path"() {
      $('#RespModalMenu').modal('hide');


    },
  },
  mounted(){
       
  }
};
</script>

<style scoped>
/*+++ all categories side +++*/

/*.all-categories-side{*/
/*  width: 400px;*/
/*  height: 100vh;*/
/*  position: fixed;*/
/*  top: 0;*/
/*  right:-420px;*/
/*  transition: all 0.3s ease;*/
/*  z-index: 100;*/
/*  box-shadow: 0 0 10px #eeeeee99;*/
/*  overflow-y: auto;*/

/*}*/
.circle-list {
  height: 10px;
  width: 10px;
  display: block;
}

.all-categories-side .card .all-categories-side-btn {
  border: none;
  background-color: unset;
}
.all-categories-side-btn svg {
  margin-top: 6px;
}
.all-categories-side .card {
  border: unset;
}
.all-categories-side .card-header {
  background-color: unset;
  border-bottom: unset;
  padding: unset;
}
.all-categories-side .all-categories-side-btn {
  padding: 0.4rem 1.25rem;
  transition: all 0.3s ease;
  position: relative;
}

.all-categories-side .all-categories-side-btn[aria-expanded="false"] svg {
  transition: all 0.3s ease-in;
}
.all-categories-side .all-categories-side-btn[aria-expanded="true"] svg {
  transform: rotateX(180deg);
  transition: all 0.3s ease-in;
}

.all-categories-side .all-categories-side-btn:hover {
  color: var(--color-theme);
}
.all-categories-side .all-categories-side-btn svg > path {
  transition: 0.3s;
}
.all-categories-side .all-categories-side-btn:hover svg > path {
  stroke: var(--color-theme);
}
.all-categorie-sub-menu {
  list-style-type: none;
  border-right: 1px solid var(--color-ea);
}
.all-categorie-sub-menu a {
  display: block;
  color: var(--color-444);
  transition: 0.3s;
  padding: 10px;
  font-size: 15px;
}
.all-categorie-sub-menu a:hover,
.all-categories-side a:hover {
  color: var(--color-theme);
}
.all-categories-side-img {
  width: 80px;
  /*height: 50px;*/
}
.all-categories-side-img img {
  width: 100%;
  height: 100%;
}
.fade-right {
  transform: translateX(100vw);
  transition: all 0.25s ease-out;
}

.fade-right.show {
  transform: translateX(0);
  transition: all 0.25s ease-out;
}
.modal-label-close {
  display: block !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
.modal-dialog {
  margin: 0 0 !important;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100% !important;
}
.modal-content {
  height: 100%;
  overflow-y: auto;
}
/*+++ End all categories side +++*/
@media screen and (max-width: 400px) {
  .all-categories-side {
    width: 100%;
  }
}
</style>